export default "__VITE_ASSET__DhqFDVWK__"